import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { TSelectedFieldAssetsStoreState } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import type { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import {
  POST_FILTER_PRESSURE_VALUE_TYPE,
  PRE_FILTER_PRESSURE_VALUE_TYPE,
} from 'utils/prePostFilterValueTypes'
import { chooseAmongstUnAggHourlyAndDaily } from '../../../chooseAmongstUnAggHourlyAndDaily'

export const getPrePostFilterArgs = ({
  selectedValueGroups,
  selectedFieldAssets,
}: {
  selectedValueGroups: ReturnType<typeof selectedValueGroupsStore.getState>['selectedValueGroups']
  selectedFieldAssets: TSelectedFieldAssetsStoreState
}): Partial<routes.Values.Request> => {
  if (!selectedValueGroups.irrigation_activity_pressure || !selectedFieldAssets.prePostFilterPoint) return {}

  const intervalToRequest = chooseAmongstUnAggHourlyAndDaily({ excludeFuture: true })

  // pressure is not shown for long date ranges, so there is nothing to fetch
  if (intervalToRequest === 'DAILY') return {}

  const preferredAggregationInterval = { preferredAggregationInterval: intervalToRequest }

  const valuesRequestedForPoints: Record<string, typeof preferredAggregationInterval> = {
    [PRE_FILTER_PRESSURE_VALUE_TYPE]: preferredAggregationInterval,
    [POST_FILTER_PRESSURE_VALUE_TYPE]: preferredAggregationInterval,
  }

  return {
    points: {
      lngLats: [selectedFieldAssets.prePostFilterPoint],
      valuesRequested: valuesRequestedForPoints,
    },
  }
}
